// extracted by mini-css-extract-plugin
export default {"button-wrapper":"_2B0OL","buttonWrapper":"_2B0OL","dot":"_1RV54"};